import { FC } from 'react'
import { Button } from 'antd'
import { ShowIf } from '../../../core/component'
import { DeleteOutlined, EyeOutlined, SaveOutlined } from '@ant-design/icons'
import { CloseButton } from 'react-bootstrap'

export const ContactFormRelationsActions: FC<{
  value?: number,
  index: number,
  remove: () => void,
  removeLoading: boolean,
  save: () => void,
  saveLoading: boolean,
  cancel: () => void,
  view: () => void,
  viewDisabled?: boolean,
}> = ({value, remove, removeLoading, cancel, save, saveLoading, view, viewDisabled}) => {
  return (
    <div
      style={{
        display: 'inline-flex',
        flexWrap: 'nowrap',
        alignItems: 'center',
        gap: 2,
        whiteSpace: 'nowrap',
      }}
    >
      <Button
        size='small'
        loading={saveLoading}
        type='text'
        shape='circle'
        icon={<SaveOutlined/>}
        onClick={save}
      />

      <ShowIf
        condition={!!value}
        replacement={
          <Button
            size='small'
            icon={<CloseButton/>}
            shape='circle'
            type='text'
            onClick={cancel}
          />
        }>

        <Button
          size='small'
          loading={removeLoading}
          danger
          icon={<DeleteOutlined/>}
          shape='circle'
          type='text'
          onClick={remove}
        />

        <Button
          size='small'
          icon={<EyeOutlined/>}
          shape='circle'
          type='text'
          onClick={view}
          disabled={viewDisabled}
        />
      </ShowIf>
    </div>
  )
}